import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { defer, NEVER } from 'rxjs';
import { finalize, share } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class CustomMessageService {
  
  constructor(private router: Router, private messageService: MessageService) {}

  public readonly spinner$ = defer(() => {
    this.showModalLoading();
    return NEVER.pipe(
      finalize(() => {
        this.closeAllModal();
      })
    );
  }).pipe(share());

  customSwal() {
    return Swal.mixin({
      allowOutsideClick: false,
      reverseButtons: true,
      customClass: {
        title: 'swal-title',
        icon: 'swal-icon',
        input: 'form-control-sm',
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-default',
        actions: 'd-flex justify-content-around',
      },
      buttonsStyling: false,
    });
  }

  showToast(message: string, type: string, detail?: string, life?: number) {
    this.messageService.add({
      severity: type,
      summary: message,
      detail: detail ?? '',
      life: 5000,
    });
  }

  /*
  showToastMessage(response: any) {
    // Swal.close();
    switch (response.retorno.codigo) {
      case 200: this.toastr.success(response.retorno.mensagem, 'Sucesso!');
        break;
      case 300: this.toastr.warning(response.retorno.mensagem, 'Alerta!');
        break;
      case 400: this.toastr.info(response.retorno.mensagem, 'Informação!');
        break;
      case 500: this.toastr.error(response.retorno.mensagem, 'Erro!');
        break;
      case 600: this.toastr.info(response.retorno.mensagem, 'Informação!');
        break;
      default:this.toastr.info(response.retorno.mensagem, 'Informação!');
        break;
    }
  }

  showToastSuccess(message: string){
    this.toastr.success(message);
  }

  showToastInfo(message: string){
    this.toastr.info(message);
  }

  showToastWarning(message: string){
    this.toastr.warning(message);
  }

  showToastError(message: string){
    this.toastr.error(message);
  }*/

  closeAllModal() {
    Swal.close();
  }

  showModalLoading() {
    Swal.fire({
      allowOutsideClick: false,
    });
    this.customSwal().showLoading();
  }

  showModalNormalMessage(message: string) {
    Swal.fire({
      allowOutsideClick: false,
      text: message,
      icon: 'error',
    });
  }

  showModalConfirmation(
    title,
    text,
    icon,
    confirmButtonText,
    cancelButtonText,
    success,
    cancel
  ) {
    Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonColor: '#2196F3',
      cancelButtonColor: '#ddd',
      confirmButtonText,
      cancelButtonText,
    }).then((result) => {
      if (result.isConfirmed) {
        success();
      } else if (String(result.dismiss) == 'cancel') {
        cancel();
      }
    });
  }

  showModalSuccessMessage(message: string, title = 'Sucesso') {
    Swal.fire({
      allowOutsideClick: false,
      title: title ? title : '',
      text: message,
      icon: 'success',
    });
  }

  showModalErrorMessage(message: string, title = 'Erro') {
    Swal.fire({
      allowOutsideClick: false,
      title: title ? title : '',
      text: message,
      icon: 'error',
    });
  }
}

// SUCESSO(200),REGRA_NEGOCIO(300),NENHUM_RESGISTRO(400),ERRO_INTERNO(500),INFORMACAO(600);
